import "./App.css";
import { Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import Login from "./pages/Login";
import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect } from "react";
import ArtistMain from "./pages/ArtistMain";
//import Header from "./components/Header";
import SignupForm from "./pages/Artistsignup";
import LoggedIn from "./pages/Loggedinartist";
import ArtistCalender from "./pages/artistcalender.js";
import Me from "./pages/me.js";
import ArtistProfile from "./pages/ArtistProfile";
import Launch from "./pages/Launch.js";
import LaunchQRModal from "./components/LaunchQRModal.js";

import EventDetails from "./pages/EventDetails.js";
import EventOverview from "./pages/EventOverview.js";
import BusinessLoggedInArtist from "./pages/bussiness/BusinessLoggedinartist.js";
import QrCode from "./pages/bussiness/BusinessQr.js";
import BusinessCalendar from "./pages/bussiness/Businesscalender.js";
import BusinessProfile from "./pages/bussiness/ArtistProfile.js";
import BusinessEventDetails from "./pages/bussiness/BusinessEventDetails.js";
import BusinessSignup from "./pages/bussiness/BusinessSignup.js";
import Rewards from "./pages/Rewards.js";
import { ToastContainer } from "react-toastify";
import { AuthService, fetchWithAuth } from "./lib/authService";
import { API_ENDPOINTS } from "./lib/config";
// import Waiter from "./pages/Waiter/Main.js";
// import OrderDetailsPage from "./pages/Waiter/Order.js";

function App() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault(); // Suppress automatic install popup
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt,
      );
    };
  }, []);

  // When website loads, check if token is expired, refresh it if needed, and route to business or normal page
  useEffect(() => {
    const initAuth = async () => {
      const token = AuthService.getAccessToken();
      const refreshToken = AuthService.getRefreshToken();

      if (!token && !refreshToken) {
        return;
      }

      // Check if access token is expired
      if (AuthService.isTokenExpired()) {
        if (refreshToken && !AuthService.isRefreshTokenExpired()) {
          try {
            console.log("[App] Access token expired, attempting refresh...");
            await AuthService.refreshToken();
          } catch (err) {
            console.warn("[App] Token refresh failed:", err);
            AuthService.clearTokens();
            try {
              localStorage.clear();
            } catch (e) {}
            return;
          }
        } else {
          console.log("[App] Both tokens expired, clearing session");
          AuthService.clearTokens();
          try {
            localStorage.clear();
          } catch (e) {}
          return;
        }
      }

      // Token is valid (or refreshed) — verify session with partner endpoint
      try {
        const sessionRes = await fetchWithAuth(API_ENDPOINTS.PARTNER, {
          method: "GET",
        });

        if (!sessionRes.ok) {
          throw new Error("Session fetch failed");
        }

        const data = await sessionRes.json();
        localStorage.setItem("isWaiter", Boolean(data.role?.includes("Waiter")));
        localStorage.setItem("isKj", Boolean(data.role?.includes("KJ")));
        localStorage.setItem("PerformerId", data.id || "");

        const isBusinessStored = localStorage.getItem("isBusiness");
        const isBusinessUser =
          isBusinessStored !== null
            ? JSON.parse(isBusinessStored)
            : Boolean(data.isBusinessUser);

        // Check if registration is complete
        const isUserRegisteredLocal = localStorage.getItem("isUserRegistered");
        const hasCompletedProfile = Boolean(
          data?.display_name &&
          data.display_name.trim().length > 0 &&
          (data?.category || (Array.isArray(data?.role) && data.role.length > 0))
        );

        let hasActiveSubscription = true;
        if (!isBusinessUser) {
          try {
            const subRes = await fetchWithAuth(API_ENDPOINTS.PAYTM_SUBSCRIPTION, {
              method: "GET",
            });
            if (subRes.ok) {
              const subData = await subRes.json();
              const status = (subData?.status || "").toLowerCase();
              hasActiveSubscription =
                status === "active" ||
                status === "subscribed" ||
                status === "authenticated";
            } else {
              hasActiveSubscription = false;
            }
          } catch {
            hasActiveSubscription = false;
          }
        }

        const isFullyRegistered =
          isUserRegisteredLocal !== "false" &&
          hasCompletedProfile &&
          hasActiveSubscription;

        if (isFullyRegistered) {
          localStorage.setItem("isUserRegistered", "true");
          // If on root ("/") or register route, redirect to the user's dashboard
          if (location.pathname === "/" || location.pathname === "/Registerartist") {
            navigate(isBusinessUser ? "/loggedinartistbussiness" : "/loggedinartist", {
              replace: true,
            });
          }
        } else {
          localStorage.setItem("isUserRegistered", "false");
          // If on root ("/") and not registered, clear tokens so clean login page renders
          if (location.pathname === "/" || location.pathname === "/Registerartist") {
            AuthService.clearTokens();
            try {
              localStorage.clear();
            } catch (e) {}
          }
        }
      } catch (error) {
        console.warn("[App] Session verification error on load:", error);
      }
    };

    initAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Run once on initial website load


  return (
    <div
      className="flex flex-col items-center justify-start w-full min-h-screen bg-transparent"
      style={{ fontFamily: "manrope", minHeight: "100vh" }}
    >
      {/* {!shouldHideHeader && <Header />}  */}

      <div className="flex flex-1 w-full">
        <LaunchQRModal />
        <ToastContainer position="top-center" autoClose={3000} />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/artist" element={<ArtistMain />} />
          <Route path="/artistsignup" element={<SignupForm />} />
          <Route path="/businesssignup" element={<BusinessSignup />} />
          <Route path="/business-signup" element={<BusinessSignup />} />
          <Route path="/Registerartist" element={<Login />} />
          <Route path="/loggedinartist" element={<LoggedIn />} />
          <Route path="/bookevent" element={<ArtistCalender />} />
          <Route path="/EventDetails/:id" element={<EventDetails />} />
          <Route path="/venue/:eventId/overview" element={<EventOverview />} />
          <Route path="/EventDetails/:id" element={<EventDetails />} />
          <Route
            path="/loggedinartistbussiness"
            element={<BusinessLoggedInArtist />}
          />
          <Route path="/businessQr" element={<QrCode />} />
          <Route path="/businessCalendar" element={<BusinessCalendar />} />
          <Route path="/businessProfile" element={<BusinessProfile />} />
          <Route
            path="/businessEventDetails/:id"
            element={<BusinessEventDetails />}
          />
          <Route path="/me" element={<Me />} />
          <Route path="/artistprofile" element={<ArtistProfile />} />
          <Route path="/rewards" element={<Rewards />} />

          <Route path="/launch" element={<Launch />} />
          <Route path="*" element={<Navigate to="/" replace />} />
          {/* Add more routes as needed */}

          {/* <Route path="/Waiter" element={<Waiter />} />
          <Route path="/Waiter/orders/:orderId" element={<OrderDetailsPage />} /> */}
        </Routes>
      </div>
    </div>
  );
}

export default App;
